import React from "react";
import * as Icons from "lucide-react";
import { process } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Process() {
  return (
    <section className="relative py-24 md:py-32 bg-[#3A302A] text-[#FAF5EF] overflow-hidden">
      <div className="absolute top-1/2 -right-40 w-[420px] h-[420px] rounded-full bg-[#B0603F]/20 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="text-center mb-16 md:mb-24">
          <span className="font-body text-xs tracking-luxe uppercase text-[#C88A63]">Méthode</span>
          <h2 className="font-serif-display text-5xl md:text-7xl font-light mt-3">
            Comment <span className="font-script text-[#C88A63]">on collabore</span>
          </h2>
          <p className="max-w-xl mx-auto mt-5 font-body text-[#E7D8C6]">
            Un processus simple et transparent, du premier message jusqu'à la livraison de votre contenu.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-4 gap-8 md:gap-6">
          {process.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Circle;
            return (
              <Reveal key={p.step} delay={i * 100}>
                <div className="relative text-center md:text-left">
                  <div className="flex items-center justify-center md:justify-start gap-4 mb-5">
                    <span className="inline-flex w-14 h-14 rounded-full border border-[#B79A80]/40 items-center justify-center text-[#C88A63]">
                      <Icon size={24} />
                    </span>
                    <span className="font-serif-display text-5xl text-[#5A4B41]">{p.step}</span>
                  </div>
                  <h3 className="font-serif-display text-2xl mb-2">{p.title}</h3>
                  <p className="font-body text-sm text-[#C9BCB0] leading-relaxed">{p.text}</p>
                  {i < process.length - 1 && (
                    <span className="hidden md:block absolute top-7 -right-3 text-[#5A4B41]">
                      <Icons.ChevronRight size={22} />
                    </span>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
